const SAVE_PROFESSIONAL = '@@doctorCard/SAVE_PROFESSIONAL';
export const DoctorCardActions = { SAVE_PROFESSIONAL };

export const saveProfessional = (professional) => {
    return {
        type: SAVE_PROFESSIONAL,
        professional,
    };
};
